import React, { createContext, useContext } from 'react'
import { type AuthUser, type Profile } from '@/contexts/AuthContext'

interface AuthenticatedUserContextType {
  user: AuthUser
  profile: Profile
}

const AuthenticatedUserContext = createContext<AuthenticatedUserContextType | undefined>(undefined)

export function AuthenticatedUserProvider({
  children,
  user,
  profile,
}: {
  children: React.ReactNode
  user: AuthUser
  profile: Profile
}) {
  return (
    <AuthenticatedUserContext.Provider value={{ user, profile }}>
      {children}
    </AuthenticatedUserContext.Provider>
  )
}

export function useOptionalAuthenticatedUser() {
  return useContext(AuthenticatedUserContext)
}

export function useAuthenticatedUser() {
  const context = useContext(AuthenticatedUserContext)
  if (context === undefined) {
    throw new Error('useAuthenticatedUser must be used within an AuthenticatedUserProvider')
  }
  return context
}
